var _desc, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "12px",
    viewBox: "0 0 24 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Battery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OS_Head",
    transform: "translate(-1289.000000, -38.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1291.00325,38 L1307.99675,38 C1308.83456,38 1309.5,38.6695784 1309.5,39.4955452 L1309.5,48.5044548 C1309.5,49.3204455 1308.82697,50 1307.99675,50 L1291.00325,50 C1290.16544,50 1289.5,49.3304216 1289.5,48.5044548 L1289.5,39.4955452 C1289.5,38.6795545 1290.17303,38 1291.00325,38 Z M1291.00021,39.0461538 C1290.72395,39.0461538 1290.5,39.2727559 1290.5,39.5534511 L1290.5,48.4927027 C1290.5,48.7728753 1290.72759,49 1291.00021,49 L1307.99979,49 C1308.27605,49 1308.5,48.7733979 1308.5,48.4927027 L1308.5,39.5534511 C1308.5,39.2732786 1308.27241,39.0461538 1307.99979,39.0461538 L1291.00021,39.0461538 Z M1291.99639,40 L1307.00361,40 C1307.27382,40 1307.5,40.2240528 1307.5,40.5004358 L1307.5,47.4995642 C1307.5,47.7692032 1307.27776,48 1307.00361,48 L1291.99639,48 C1291.72618,48 1291.5,47.7759472 1291.5,47.4995642 L1291.5,40.5004358 C1291.5,40.2307968 1291.72224,40 1291.99639,40 Z M1310.5,46.5 L1310.5,41.5 L1311.00314,41.5 L1312.5,43 L1312.5,45 L1311.00314,46.5 L1310.5,46.5 Z",
    id: "Battery",
    style: {
      mixBlendMode: "hard-light"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.6cb88aa66a9ec4752b3920c087b50e96.svg";
export { ForwardRef as ReactComponent };